import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Modal,
  Select,
  Skeleton,
  Text,
  TextInput,
  Paper,
  Group,
  ThemeIcon,
  Title,
  Grid,
  ActionIcon,
  Badge,
} from "@mantine/core";

import { IconUser, IconCircleCheck, IconFile } from "@tabler/icons-react";

import { Search } from "tabler-icons-react";
import flat from "flat";
import { showNotification } from "@mantine/notifications";
import { BeatLoader } from "react-spinners";
import {
  loadingStates,
  validateEmail,
  validateMobile,
} from "../../utilities/utilities";
import colors from "../../utilities/design";
import AgreementListModal from "./AgreementListModal";

const AgreementForm1 = ({ form, setUiConfigs, uiConfigs, save }) => {
  const agreementFormJson = flat.unflatten(form.values);

  // Improved saveNext function with detailed validation
  const saveNext = async () => {
    // 1. Initialize a clean local error object
    const keys = {};

    // 2. Destructure for cleaner logic
    const relType = agreementFormJson?.relationshipType;
    const relWith = agreementFormJson?.relationshipWith;
    const title = agreementFormJson?.titleOfAgreement;
    const category = agreementFormJson?.typeOfAgreement;
    const reqUser = agreementFormJson?.requestingUser;

    // 3. Document Type Validation
    if (!relType || relType.trim().length < 3) {
      keys.relationshipType = "Please select a contract type.";
    }

    // 4. Connected Agreement
    const isSupplementary =
      relType === "Supplementary" ||
      relType === "Supplementary to Supplementary";
    if (isSupplementary) {
      // Check if it's null, undefined, or empty string
      if (!relWith || relWith.toString().trim().length === 0) {
        keys.relationshipWith = "Please select the parent contract.";
      }
    }

    // 5. Category & Title Validation
    if (!category || category.trim().length < 3) {
      keys.typeOfAgreement = "Please select a contract category.";
    }

    if (!title || title.trim().length < 3) {
      keys.titleOfAgreement = "Please select a contract title.";
    } else if (title.length > 50) {
      keys.titleOfAgreement =
        "Title of the agreement should should not be more than 50 characters.";
    }

    // 6. User Details Validation
    if (!reqUser?.name || reqUser.name.trim().length < 3) {
      keys["requestingUser.name"] = "Enter at least 3 characters.";
    }

    if (!reqUser?.email || !validateEmail(reqUser.email)) {
      keys["requestingUser.email"] = "Enter a valid email address.";
    }

    // 7. Execution Logic
    console.log("Validation errors:", keys);

    if (Object.keys(keys).length > 0) {
      // Using your component's specific error setter
      form.setErrors(keys);

      showNotification({
        color: "red",
        title: "Validation Error",
        message: "Please complete all mandatory fields before continuing.",
        autoClose: 3000,
      });
    } else {
      // Clear errors if any existed from a previous failed attempt
      form.setErrors({});

      await save();
      setUiConfigs({
        ...uiConfigs,
        currentStep: 1,
      });
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState(0);

  const handleSearchClick = () => {
    // Set the showModal state to true when the button is clicked
    setShowModal(true);
  };

  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const typeOfDocuments = [
    "Parent",
    "Supplementary",
    "Supplementary to Supplementary",
  ];
  console.log(selectedAgreement);
  useEffect(() => {
    if (selectedAgreement) {
      form.setFieldValue("relationshipWith", `${selectedAgreement}`);
    }
  }, [selectedAgreement]);

  return (
    <div className="w-full flex flex-col my-4">
      <div className="mb-8">
        <Group justify="space-between" mb="xl">
          <Group gap="md">
            <ThemeIcon radius="xl" size={38} variant="light">
              <IconFile size={20} />
            </ThemeIcon>

            <div>
              <Title order={5}>Contract Information</Title>

              <Text c="dimmed" size="xs">
                Enter the primary details of the contract.
              </Text>
            </div>
          </Group>
        </Group>
        <hr></hr>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
          <div>
            <Select
              required
              size="md"
              radius="md"
              label="Contract Type"
              placeholder="Select Contract Type"
              data={typeOfDocuments.map((value) => ({ value, label: value }))}
              {...form.getInputProps("relationshipType")}
              onCreate={(query) => {
                form.setFieldValue(
                  "relationshipType",
                  Array.from(
                    new Set([...(form.values.relationshipType || []), query]),
                  ),
                );
              }}
              styles={{
                error: {
                  fontSize: 12,
                  marginTop: 4,
                  textTransform: "none",
                },
                flex: 1,
              }}
            />
          </div>
          <div>
            <TextInput
              label="Connected Contract Number"
              readOnly
              size="md"
              radius="md"
              placeholder="Search and select parent contract"
              {...form.getInputProps("relationshipWith")}
              required={
                agreementFormJson.relationshipType === "Supplementary" ||
                agreementFormJson.relationshipType ===
                  "Supplementary to Supplementary"
              }
              type="number"
              onChange={(event) => {
                // const value = event.currentTarget.value;
                // const commaSeparatedValues = value.split(",").map((v) => v.trim());
                form.setFieldValue(
                  "relationshipWith",
                  event.currentTarget.value,
                );
              }}
              styles={{
                error: {
                  fontSize: 12,
                  marginTop: 4,
                  textTransform: "none",
                },
                flex: 1,
              }}
              rightSection={
                <ActionIcon
                  variant="filled"
                  color="#1b6f8d"
                  radius="md"
                  size={34}
                  onClick={handleSearchClick}
                  style={{
                    marginRight: 6,
                  }}
                >
                  <Search size={18} strokeWidth={2.5} />
                </ActionIcon>
              }
            />
          </div>
        </div>
        {/* <div className="grid grid-cols-2">
        <div></div>
        <Button
          className="mt-2 max-w-lg"
          color="green"
          onClick={handleSearchClick} // Call the handler on button click
          style={{maxWidth:"42%"}}
        >
          Search for Agreements
        </Button>
      </div> */}
        {agreementFormJson.typeOfAgreementData.length === 0 ||
        agreementFormJson.typeOfAgreementData.length ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-5">
            <Select
              searchable
              size="md"
              radius="md"
              required
              creatable
              styles={{
                error: {
                  fontSize: 12,
                  marginTop: 4,
                  textTransform: "none",
                },
                flex: 1,
              }}
              label="Contract Category"
              placeholder="Select Contract Category"
              data={agreementFormJson.typeOfAgreementData}
              getCreateLabel={(query) => `+ add ${query}`}
              onCreate={(query) => {
                form.setFieldValue(
                  "typeOfAgreementData",
                  Array.from(
                    new Set([
                      ...(form.values.typeOfAgreementData || []),
                      query,
                    ]),
                  ),
                );
              }}
              {...form.getInputProps("typeOfAgreement")}
            />
            <Select
              searchable
              size="md"
              radius="md"
              required
              creatable
              label="Contract Title"
              placeholder="Select Contract Title"
              styles={{
                error: {
                  fontSize: 12,
                  marginTop: 4,
                  textTransform: "none",
                },
                flex: 1,
              }}
              data={agreementFormJson.titleOfAgreementData}
              getCreateLabel={(query) => `+ add ${query}`}
              onCreate={(query) => {
                form.setFieldValue(
                  "titleOfAgreementData",
                  Array.from(
                    new Set([
                      ...(form.values.titleOfAgreementData || []),
                      query,
                    ]),
                  ),
                );
              }}
              {...form.getInputProps("titleOfAgreement")}
            />
          </div>
        ) : (
          <Skeleton height={50} />
        )}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-5">
          <TextInput
            label="Job Order"
            size="md"
            radius="md"
            mt="5"
            styles={{
              error: {
                fontSize: 12,
                marginTop: 4,
                textTransform: "none",
              },
              flex: 1,
            }}
            placeholder="Enter Job Order"
            {...form.getInputProps("jobOrder")}
          />
        </div>
        {showModal && (
          <Modal
            overflow="inside"
            opened
            onClose={handleCloseModal} // Call the handler on modal close
            size="calc(80vw)"
          >
            <AgreementListModal
              onCloseAgreement={handleCloseModal}
              setSelectedAgreement={setSelectedAgreement}
            />
          </Modal>
        )}
      </div>

      <Group justify="space-between" mb="xl">
        <Group gap="md">
          <ThemeIcon radius="xl" size={38} variant="light">
            <IconUser size={20} />
          </ThemeIcon>

          <div>
            <Title order={5}>Requesting User</Title>

            <Text c="dimmed" size="xs">
              Information is auto-filled from the logged-in user's profile.
            </Text>
          </div>
        </Group>
      </Group>
      <hr></hr>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-5">
        <TextInput
          required
          size="md"
          radius="md"
          label="Name"
          placeholder="Enter Name"
          styles={{
            error: {
              fontSize: 12,
              marginTop: 4,
              textTransform: "none",
            },
            flex: 1,
          }}
          {...form.getInputProps("requestingUser.name")}
        />
        <TextInput
          required
          size="md"
          radius="md"
          label="Email Address"
          placeholder="Enter Email Address"
          styles={{
            error: {
              fontSize: 12,
              marginTop: 4,
              textTransform: "none",
            },
            flex: 1,
          }}
          {...form.getInputProps("requestingUser.email")}
        />
        {/* <TextInput
          label="Phone"
          placeholder="Enter 10 digit phone no."
          {...form.getInputProps("requestingUser.phone")}
        /> */}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-5">
        <TextInput
          label="Designation"
          size="md"
          radius="md"
          placeholder="Enter Designation"
          styles={{
            error: {
              fontSize: 12,
              marginTop: 4,
              textTransform: "none",
            },
            flex: 1,
          }}
          {...form.getInputProps("requestingUser.designation")}
        />
        <TextInput
          label="Department"
          size="md"
          radius="md"
          placeholder="Enter Department"
          styles={{
            error: {
              fontSize: 12,
              marginTop: 4,
              textTransform: "none",
            },
            flex: 1,
          }}
          {...form.getInputProps("requestingUser.businessDepartment")}
        />
      </div>
      <div
        className="flex justify-end mt-8 pt-6"
        style={{
          borderTop: "1px solid #edf2f7",
        }}
      >
        <div />
        {uiConfigs.loading === loadingStates.LOADING ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <Button size="md" radius="md" px={28} onClick={saveNext}>
            Next →
          </Button>
        )}
      </div>
    </div>
  );
};

export default AgreementForm1;
